import React, { useState, useEffect } from 'react';
import { Info } from 'lucide-react';
import { toast } from 'react-toastify';

const BookScheduleModal = ({ isOpen, closeSchedule, Builiding_name, property_id }) => {
    const login = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12")) || {};

    const [formData, setFormData] = useState({
        visit_type: 'pick_drop',
        name: '',
        email: '',
        mobile: '',
        date: '',
        time: '',
        description: '',
        user_id: login.user_id || 'HBTR0007',
        property_id: '',
        other: ''
    });

    const [errors, setErrors] = useState({});
    const [submittedOnce, setSubmittedOnce] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dateError, setDateError] = useState('');

    const validateField = (name, value) => {
        switch (name) {
            case 'name':
                return value.trim() === '';
            case 'email':
                return !/\S+@\S+\.\S+/.test(value);
            case 'mobile':
                return !/^\d{10}$/.test(value);
            case 'date':
                return value.trim() === '';
            case 'time':
                return value.trim() === '';
            case 'description':
                return value.trim() === '';
            default:
                return false;
        }
    };

    const handleChange = (e) => {
        let { name, value } = e.target;

        // Mobile formatting
        if (name === 'mobile') {
            value = value.replace(/\D/g, '');
            if (value.startsWith("91") && value.length > 10) value = value.slice(2);
            else if (value.startsWith("0") && value.length > 10) value = value.slice(1);
            value = value.slice(0, 10);
        }

        setFormData(prev => ({ ...prev, [name]: value }));

        if (submittedOnce) {
            setErrors(prev => ({ ...prev, [name]: validateField(name, value) }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmittedOnce(true);
        setDateError('');

        // Validation
        const newErrors = {};
        Object.entries(formData).forEach(([key, val]) => {
            if (['visit_type', 'user_id', 'property_id', 'other'].includes(key)) return;
            newErrors[key] = validateField(key, val);
        });

        setErrors(newErrors);

        const hasErrors = Object.values(newErrors).some(Boolean);
        if (hasErrors) {
            toast.error('Please fix the errors.');
            return;
        }

        // Date must not be in the past
        const selectedDate = new Date(formData.date);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        selectedDate.setHours(0, 0, 0, 0);
        if (selectedDate < today) {
            setDateError("Date cannot be in the past.");
            return;
        }

        setLoading(true);
        try {
            const response = await fetch(`https://100real.xyz/schedule`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });

            const res = await response.json();
            if (response.ok) {
                toast.success('Schedule booked successfully!');
                setFormData({
                    visit_type: 'pick_drop',
                    name: '',
                    email: '',
                    mobile: '',
                    date: '',
                    time: '',
                    description: '',
                    user_id: login.user_id || 'HBTR0007',
                    property_id: '',
                    other: ''
                });
                setErrors({});
                setSubmittedOnce(false);
                closeSchedule();
            } else {
                toast.error(res.message || 'Failed to submit schedule.');
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (Builiding_name || property_id) {
            setFormData(prev => ({
                ...prev,
                other: Builiding_name || '',
                property_id: property_id || ''
            }));
        }
    }, [Builiding_name, property_id]);

    if (!isOpen) return null;

    return (
        <div className="feed-modal-overlay">
            <div className="feed-modal">
                <button onClick={closeSchedule} className="feed-close-btn">×</button>
                <h2 className="feed-modal-heading">Book Schedule</h2>
                <form onSubmit={handleSubmit}>
                    {/* Visit Type */}
                    <div className="form-group-fb">
                        <label>Visit Type:</label>
                        <div className="visit-type-options">
                            {['pick_drop', 'virtual'].map(type => (
                                <label key={type} className={`visit-type-label ${formData.visit_type === type ? 'selected' : ''}`}>
                                    <input
                                        type="radio"
                                        name="visit_type"
                                        value={type}
                                        checked={formData.visit_type === type}
                                        onChange={handleChange}
                                        className="hidden-radio-visit"
                                    />
                                    {type === 'pick_drop' ? 'Pick & Drop' : 'Virtual Site Visit'}
                                </label>
                            ))}
                        </div>
                    </div>

                    {/* Name */}
                    <InputField name="name" label="Name" value={formData.name} onChange={handleChange} error={errors.name} />

                    {/* Mobile */}
                    <InputField name="mobile" label="Phone" value={formData.mobile} onChange={handleChange} error={errors.mobile} type="tel" placeholder="10-digit Mobile Number" />

                    {/* Email */}
                    <InputField name="email" label="Email" value={formData.email} onChange={handleChange} error={errors.email} type="email" />

                    {/* Date */}
                    <InputField name="date" label="Date" value={formData.date} onChange={handleChange} error={errors.date || dateError} type="date" />

                    {/* Time */}
                    <InputField name="time" label="Time" value={formData.time} onChange={handleChange} error={errors.time} type="time" />

                    {/* Description */}
                    <InputField name="description" label="Message" value={formData.description} onChange={handleChange} error={errors.description} type="text" />

                    <button type="submit" className="submit-btn-fb" disabled={loading}>
                        {loading ? "Submitting..." : "Book Now"}
                    </button>
                </form>
            </div>
        </div>
    );
};

// Reusable Input Field with Error Icon
const InputField = ({ name, label, value, onChange, error, type = "text", placeholder = "" }) => (
    <div className="form-group-fb" style={{ position: 'relative' }}>
        <label>{label}</label>
        <input
            name={name}
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className={error ? 'input-error' : ''}
            style={{ paddingRight: '35px' }}
        />
        {error && (
            <Info
                className="input-icon"
                style={{ position: 'absolute', right: '10px', top: '38px', color: 'red', pointerEvents: 'none' }}
            />
        )}
    </div>
);

export default BookScheduleModal;
